import { BetSlipMode, SelectionConditionEnum } from "../types/enums";
import { StateActionTypes } from "../types/enums";
import {
  dispatchCustomEvent,
  findSelectionCondition,
} from "../shared/utils/bet-slip";
import { convertSelectionToBetBuilderBet } from "../shared/utils/bet-builder";

export const selectionHandlers: ReducerHandlers = {
  [StateActionTypes.ADD_SELECTION]: (state, action) => {
    const { sourcePage, ...newSelection } = action.payload;
    const condition = findSelectionCondition({
      newSelection,
      betSlipState: state.betSlipState,
      betBuilderMarketIds: state.config.betBuilder.betBuilderMarketIds || [],
      sourcePage,
    });

    let newSelections: IBetSlipSelection[] = [];

    switch (condition) {
      case SelectionConditionEnum.NotInNormalSelectionsNotInWidget:
        console.log("AA");
        const currentTotalSelections =
          state.betSlipState.selections.length +
          state.betSlipState.betBuilderState.totalOdds.length;
        if (
          state.config.brand.selectionsLimit > 0 &&
          currentTotalSelections >= state.config.brand.selectionsLimit
        ) {
          dispatchCustomEvent(StateActionTypes.BETSLIP_SELECTIONS_LIMIT);
          newSelections = state.betSlipState.selections;
          break;
        }
        // add selection
        newSelections = [...state.betSlipState.selections, newSelection];
        break;

      case SelectionConditionEnum.NotBBInWidget:
        console.log("BB");
        // widget prompt replace bb - handled by ConfirmBannerProvider
        // Dispatch custom event to trigger confirm dialog
        dispatchCustomEvent(StateActionTypes.SHOW_BB_CONFIRM, {
          pendingSelection: newSelection,
        });
        return state;

      case SelectionConditionEnum.NotBBInNormalSelections:
        console.log("CC");
        const existingSelection = state.betSlipState.selections.find(
          (selection: IBetSlipSelection) =>
            selection.eventId === newSelection.eventId &&
            selection.betTypeId === newSelection.betTypeId &&
            selection.oddKey === newSelection.oddKey &&
            selection.oddLine === newSelection.oddLine,
        );

        if (existingSelection) {
          newSelections = state.betSlipState.selections.filter(
            (selection: IBetSlipSelection) =>
              selection.key !== existingSelection.key,
          );
        } else {
          newSelections = state.betSlipState.selections.map(
            (selection: IBetSlipSelection) =>
              selection.eventId === newSelection.eventId
                ? newSelection
                : selection,
          );
        }
        break;

      case SelectionConditionEnum.isBBInNormalSelectionsSameMarketSameOddAndNotInWidget:
        console.log("DD");
        newSelections = state.betSlipState.selections.filter(
          (selection: IBetSlipSelection) =>
            selection.eventId !== newSelection.eventId,
        );
        break;

      case SelectionConditionEnum.isBBInNormalSelectionsSameMarketDifferentOddAndNotInWidget:
        console.log("EE");
        // replace the selection
        newSelections = state.betSlipState.selections.map(
          (selection: IBetSlipSelection) =>
            selection.eventId === newSelection.eventId
              ? newSelection
              : selection,
        );
        break;

      case SelectionConditionEnum.isBBInNormalSelectionDifferentMarketNotInWidget:
        console.log("FF");
        // remove N selection => Create Widget with 2 Selection
        const newBetBuilderSelections = state.betSlipState.selections.filter(
          (bet: IBetSlipSelection) =>
            Number(bet.eventId) === newSelection.eventId &&
            state.config.betBuilder.betBuilderMarketIds.indexOf(bet.betTypeId) !== -1,
        );
        console.log("newBetBuilderSelections", newBetBuilderSelections);

        if (!newBetBuilderSelections.length) {
          newSelections = state.betSlipState.selections.map(
            (selection: IBetSlipSelection) =>
              selection.eventId === newSelection.eventId
                ? newSelection
                : selection,
          );
          break;
        }
        const existingCombinableCount = new Set(
          state.betSlipState.betBuilderState.bets.map((bet) => Number(bet.eventId)),
        ).size;
        if (
          existingCombinableCount >=
          state.config.betBuilder.amountOfCombinableBetBuilders
        ) {
          dispatchCustomEvent(StateActionTypes.BB_COMBINABLE_LIMIT);
          newSelections = state.betSlipState.selections;
          break;
        }
        const createdBets = [
          ...newBetBuilderSelections.map((selection: IBetSlipSelection) =>
            convertSelectionToBetBuilderBet(selection),
          ),
          convertSelectionToBetBuilderBet(newSelection),
        ];
        if (createdBets.length > state.betSlipState.betBuilderState.config.selectionNumber) {
          dispatchCustomEvent(StateActionTypes.BB_SELECTIONS_LIMIT);
          newSelections = state.betSlipState.selections;
          break;
        }
        dispatchCustomEvent(StateActionTypes.ADD_BB_BETS, createdBets);
        newSelections = state.betSlipState.selections.filter(
          (selection: IBetSlipSelection) =>
            selection.eventId !== newSelection.eventId,
        );
        const optimisticBets: IBetBuilderBet[] = createdBets.map((bet) => ({
          ...bet,
          id: String(bet.id),
          eventId: String(bet.eventId),
        }));
        return {
          ...state,
          betSlipState: {
            ...state.betSlipState,
            mode: BetSlipMode.Combo,
            selections: newSelections,
            betBuilderState: {
              ...state.betSlipState.betBuilderState,
              bets: [
                ...state.betSlipState.betBuilderState.bets,
                ...optimisticBets,
              ],
            },
          },
        };

      case SelectionConditionEnum.isBBInWidgetSameMarketSameOdd:
        console.log("GG");
        dispatchCustomEvent(StateActionTypes.REMOVE_BB_BETS, [
          convertSelectionToBetBuilderBet(newSelection),
        ]);

        newSelections = state.betSlipState.selections;
        break;

      case SelectionConditionEnum.isBBInWidgetSameMarketDifferentOdd:
        console.log("HH");
        dispatchCustomEvent(StateActionTypes.ADD_BB_BETS, [
          convertSelectionToBetBuilderBet(newSelection),
        ]);
        newSelections = state.betSlipState.selections;
        break;

      case SelectionConditionEnum.isBBInWidgetDifferentMarket:
        console.log("II");
        const eventBetsCount = state.betSlipState.betBuilderState.bets.filter(
          (bet) => Number(bet.eventId) === newSelection.eventId,
        ).length;
        if (
          eventBetsCount >=
          state.betSlipState.betBuilderState.config.selectionNumber
        ) {
          dispatchCustomEvent(StateActionTypes.BB_SELECTIONS_LIMIT);
          newSelections = state.betSlipState.selections;
          break;
        }
        dispatchCustomEvent(StateActionTypes.ADD_BB_BETS, [
          convertSelectionToBetBuilderBet(newSelection),
        ]);
        newSelections = state.betSlipState.selections;
        break;

      default:
        break;
    }

    const hasBetBuilder = state.betSlipState.betBuilderState.bets.length > 0;
    const newMode =
      newSelections.length >= 2 || hasBetBuilder
        ? BetSlipMode.Combo
        : BetSlipMode.Single;

    const newBetSlipState: IBetSlipState = {
      ...state.betSlipState,
      mode: newMode,
      selections: newSelections,
    };

    return {
      ...state,
      betSlipState: newBetSlipState,
    };
  },

  [StateActionTypes.REMOVE_SELECTION]: (state, action) => {
    const newSelections = state.betSlipState.selections.filter(
      (selection: IBetSlipSelection) => selection.key !== action.payload.key,
    );

    const hasBetBuilder =
      (state.betSlipState.betBuilderState?.bets?.length ?? 0) > 0;
    const newBetSlipState: IBetSlipState = {
      ...state.betSlipState,
      mode: hasBetBuilder
        ? BetSlipMode.Combo
        : newSelections.length < 2
          ? BetSlipMode.Single
          : BetSlipMode.Combo,
      selections: newSelections,
    };
    return {
      ...state,
      betSlipState: newBetSlipState,
      error: undefined,
    };
  },

  [StateActionTypes.CLEAR_ALL_SELECTIONS]: (state, action) => {
    dispatchCustomEvent(StateActionTypes.CLEAR_ALL_BB_BETS);
    const newBetSlipState: IBetSlipState = {
      ...state.betSlipState,
      mode: BetSlipMode.Single,
      selections: [],
    };
    return {
      ...state,
      betSlipState: newBetSlipState,
      error: undefined,
    };
  },
};
